/**
 * @generated SignedSource<<1ece799490d41efdc8746d37ac9fdc7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationSoftOneCreateScreenMutation$variables = {
  companyApiKey: string;
  password: string;
  username: string;
};
export type IntegrationSoftOneCreateScreenMutation$data = {
  readonly store: {
    readonly activateIntegrationSoftOne: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationSoftOneCreateScreenMutation = {
  response: IntegrationSoftOneCreateScreenMutation$data;
  variables: IntegrationSoftOneCreateScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyApiKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "companyApiKey",
            "variableName": "companyApiKey"
          },
          {
            "kind": "Variable",
            "name": "password",
            "variableName": "password"
          },
          {
            "kind": "Variable",
            "name": "username",
            "variableName": "username"
          }
        ],
        "concreteType": "IntegrationSoftOne",
        "kind": "LinkedField",
        "name": "activateIntegrationSoftOne",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSoftOneCreateScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSoftOneCreateScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5b8e4f1703d48d336ac8bf94e5a90880",
    "id": null,
    "metadata": {},
    "name": "IntegrationSoftOneCreateScreenMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationSoftOneCreateScreenMutation(\n  $companyApiKey: String!\n  $password: String!\n  $username: String!\n) {\n  store {\n    activateIntegrationSoftOne(companyApiKey: $companyApiKey, password: $password, username: $username) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "04d65c750d48df4540ff42f272c6ec14";

export default node;
